import useUser from "./useUser";

export const useIsComplianceOnly = (): boolean => {
  const { user } = useUser();
  return user?.org?.isComplianceOnly || false;
};
